import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'mdi',
	},
	breakpoint: {
		scrollBarWidth: 28,
	},
	theme: {
		themes: {
			light: {
				primary: '#db3005',
				secondary: '#7D4AFF',
				accent: '#f40b48',
			},
			dark: {
				primary: '#6A31FF',
				secondary: '#7D4AFF',
				accent: '#f40b48',
			},
		},
	},
});
